export default {"src":"/_next/static/media/searchicon.02764e57.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};